interface NavigationButtonsProps {
  isFirstStep: boolean;
  isLastStep: boolean;
  isAutoAdvancing: boolean;
  hideMainButton?: boolean;
  isCompletionStep?: boolean;
  onBack: () => void;
  onContinue: () => void;
  onSubmit: () => void;
  disabled?: boolean;
}

export const NavigationButtons = ({
  isFirstStep,
  isLastStep,
  isAutoAdvancing,
  hideMainButton = false,
  isCompletionStep = false,
  onBack,
  onContinue,
  onSubmit,
  disabled = false,
}: NavigationButtonsProps) => {
  const handleClick = () => {
    if (isLastStep) {
      onSubmit();
    } else {
      onContinue();
    }
  };

  // Don't show navigation for completion steps
  if (isCompletionStep) {
    return null;
  }

  // Don't render if there's nothing to show
  const showBackButton = !isFirstStep;
  const showMainButton = !hideMainButton && !isAutoAdvancing;

  if (!showBackButton && !showMainButton && !isAutoAdvancing) {
    return null;
  }

  return (
    <div className="flex justify-between items-center mt-8">
      {/* Back button */}
      <div>
        {showBackButton && (
          <button
            type="button"
            onClick={onBack}
            disabled={disabled || isAutoAdvancing}
            className="px-4 py-2 text-muted-foreground hover:text-foreground font-medium transition-colors disabled:opacity-50 disabled:cursor-not-allowed"
          >
            Back
          </button>
        )}
      </div>

      {/* Continue/Submit button or auto-advancing indicator */}
      <div className="flex items-center gap-3">
        {isAutoAdvancing && (
          <span className="text-sm text-muted-foreground flex items-center gap-2">
            <span className="inline-block w-3 h-3 border-2 border-primary border-t-transparent rounded-full animate-spin" />
          </span>
        )}
        {showMainButton && (
          <button
            type="button"
            onClick={handleClick}
            disabled={disabled}
            className="px-9 py-3.5 bg-primary hover:bg-primary/90 text-primary-foreground font-medium rounded-xl text-lg shadow-xs transition-all duration-200 disabled:opacity-50 disabled:cursor-not-allowed"
          >
            {isLastStep ? 'Submit' : 'Continue'}
          </button>
        )}
      </div>
    </div>
  );
};
